export default __webpack_public_path__ + "static/media/FB.f6c80434.svg";